import React from 'react';
import { useParams } from 'react-router-dom';
import { useQuery } from '@apollo/react-hooks';
import Loader from 'components/ui/LoadingIndicator';
import {
    USER_GUIDE_SCOPE_OPTIONS,
    USER_GUIDE_SCOPE,
} from '../../../../gql/userGuideScopes';
import { sanitizeRouteId } from '../../../../utils/route-params.utils';
import { UserGuideScope } from '../../../../shared/types';
import UserGuideScopeForm, {
    UserGuideScopeOptionsData,
} from './components/UserGuideScopeForm';

const UserGuideScopeAddEdit = (): JSX.Element => {
    const { _id: routeId } = useParams<{ _id?: string }>();
    const _id = sanitizeRouteId(routeId);
    const { loading, data } = useQuery<{ document: UserGuideScope }>(
        USER_GUIDE_SCOPE,
        {
            skip: !_id,
            fetchPolicy: 'network-only',
            variables: { id: _id },
        }
    );
    const {
        loading: optionsLoading,
        error: optionsError,
        data: optionsData,
    } = useQuery<UserGuideScopeOptionsData>(USER_GUIDE_SCOPE_OPTIONS, {
        fetchPolicy: 'network-only',
    });

    if (loading || optionsLoading) return <Loader />;

    const document = data?.document;
    const editGroupItems = document?.name
        ? (optionsData?.userGuideScopes ?? []).filter(
              (item) => item.name === document.name
          )
        : [];
    let initialScopes: string[] = [];

    if (editGroupItems.length) {
        initialScopes = editGroupItems.map((item) => item.scope);
    } else if (document?.scope) {
        initialScopes = [document.scope];
    }

    initialScopes.sort((first, second) => first.localeCompare(second));

    return (
        <UserGuideScopeForm
            key={_id ?? 'new'}
            document={document}
            editGroupItems={editGroupItems}
            optionsData={optionsData}
            initialScopes={initialScopes}
            scopeOptionsFailed={!!optionsError}
        />
    );
};

export default UserGuideScopeAddEdit;
